"use strict";
/**
 * @module Services.TopicAdd
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Response code returned by the server for a TOPIC_ADD request
 */
var TopicAddResponseStatus;
(function (TopicAddResponseStatus) {
    TopicAddResponseStatus[TopicAddResponseStatus["OK"] = 0] = "OK";
    TopicAddResponseStatus[TopicAddResponseStatus["EXISTS"] = 1] = "EXISTS";
})(TopicAddResponseStatus = exports.TopicAddResponseStatus || (exports.TopicAddResponseStatus = {}));
/**
 * Server response from a TOPIC_ADD request.
 */
var TopicAddResponse = /** @class */ (function () {
    /**
     * Create a new TopicAddResponse instance
     *
     * @param status  the status of the add topic request
     * @param reason  if the request has failed, this contains the reason
     */
    function TopicAddResponse(status) {
        this.status = status;
    }
    return TopicAddResponse;
}());
exports.TopicAddResponse = TopicAddResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-add/topic-add-response.js
// module id = 847
// module chunks = 1